<template lang="pug">
.posto_de_atendimento__item(@click="fireChangeMap")
	.posto_de_atendimento__title
		|{{row.name}}
	.posto_de_atendimento__endereco
		strong Endereço: {{row.endereco}}
		br
		strong Telefone: {{row.telefone}}
</template>

<script>
export default {
	name: "PostoAtendimentoResultItem",
	props: [ "row" ],
	methods: {
		fireChangeMap: function() {
			this.$emit('fireChangeMap', this.row);
		}
	}
}
</script>